export const ChineseText = {
    language: "cn",
    loginTitle: "登录",
    emailPlaceholder: "邮箱地址",
    passwordPlaceholder: "密码",
    loginButton: "登录",
    loginProcessing: "正在验证中..",
    invalidPassword: "密码错误",
    invalidEmail: "邮件地址错误",
    loginFailed: "登录失败",
    loginBanner: "https://files.xs-global.cn/public/dedication-chinese-scaled.webp",
    homeWelcome: "欢迎回来",
    homeServiceTitle1: "管理面板",
    homeServiceTitle2: "技术部",
    homeService1: "产品管理 (贸易)",
    homeService2: "用户管理",
    homeService3: "用户活动日志",
    homeService4: "教程与指南",
    homeService5: "产品管理 (制造业)",
    logout: "登出",
    appVersion: "应用版本",
    breadCrumbs: "首页",

    myOffice: "我的办公室",
    myProfile: "我的资料",
    profileDetails: "个人资料",
    profileName: "姓名",
    profileEmployeeId: "员工编号",
    profileEmail: "邮箱",
    profilePhone: "电话",
    profileRole: "角色",
    profileDepartment: "部门",
    profilePosition: "职位",
    profileReportsTo: "直属上级",
    profileMyTasks: "我的任务",
    profileRecentActivity: "我最近30天的活动",
    profileTaskName: "任务名称",
    profileTaskStatus: "状态",
    profileTaskPriority: "优先级",
    profileTaskDueDate: "截止日期",
    profileActivityDate: "日期",
    profileActivityAction: "操作",
    profileActivityStatus: "状态",
    profileActivityRemarks: "备注",
    profileNoTasks: "暂无任务",
    profileNoActivity: "最近30天暂无活动记录",
    profileLoading: "正在加载个人资料...",
    profileLoadError: "无法加载个人资料。",
    footerNavigation: "办公导航",
    quickNavigation: "快速导航",
    administration: "管理",
    myDepartment: "我的部门",
    footerMyTasks: "我的任务",
    footerTutorials: "教程与指南",
    logoutConfirmTitle: "确认登出",
    logoutConfirmMessage: "您确定要登出吗？",
    logoutCancel: "取消",
    logoutConfirm: "登出",
    loggingOut: "正在登出...",
    adminTasksTab: "任务",
    adminActivityTab: "活动",
    adminCurrentMonthTasks: "本月任务",
    adminUserActivity: "用户活动",
    adminTaskAssigner: "分配人",
    adminTaskAssignee: "接收人",
    adminPrevious: "上一页",
    adminNext: "下一页",
    adminSelectDepartment: "选择部门",
    adminSelectPosition: "选择职位",
    adminSelectManager: "选择直属上级",
    adminTopOfOrganization: "组织最高层",
    adminVerified: "已验证",
    adminServiceAccess: "服务权限",
    adminYes: "是",
    adminNo: "否",

    // New Dashboard Texts
    websiteManagement: "网站性能",
    last7Days: "最近 7 天",
    last30days: "最近 30 天",
    last90days: "最近 90 天",
    last1year: "最近 1 年",
    totalTraffic: "总流量",
    seoTraffic: "SEO 流量",
    socialMediaTraffic: "社交媒体流量",
    activeUsers: "活跃用户",
    organicUsers: "自然访问用户",
    trafficByCountry: "按国家的流量",
    top10Countries: "前 10 名",
    socialMedialSub: "社交媒体订阅",

    totalProducts: "产品总数",
    allUsers: "所有用户",
    manageButton: "管理",
    learnMoreButton: "了解更多",

    // Product PN Service Page
    pnNavMenu1: "生成产品编码",
    pnNavMenu2: "查找产品",
    pnSelectCompany: "选择公司",
    pnSelectCategory: "选择类别",
    pnSelectSubCategory: "选择子类别",
    pnProductImage: "产品图片",
    pnProductName: "产品名称",
    pnProductSpec: "规格",
    pnProductRemarks: "备注",
    pnGenerateButton: "生成产品编码",
    pnProductFiles: "数据手册 / 使用手册",

    pnAddCategoryName: "Category Name (English)",
    pnAddCategoryChineseName: "类别名称（中文）",
    pnIdentificationCode: "标识码",
    pnAddCategoryBtn: "添加类别",
    pnAddingData: "正在添加数据",
    pnAddSubCategoryName: "Sub Category Name (English)",
    pnAddSubCategoryChineseName: "子类别名称（中文）",
    pnAddSubCategoryBtn: "添加子类别",
    pnAddCategoryErrorMessage: "请添加一个由大写字母或数字组成的两位代码。",
    pnAddDuplicateCategoryCodeError: "输入的产品料号已存在！",
    pnAddCategoryFailedError: "添加失败！",


    pnProductOverview: "产品概述",
    pnCreateProductPnBtn: "创建产品零件号",
    pnCreatingProductData: "正在创建数据...",
    pnGeneratedProductPn: "生成的产品零件号",
    pnCopy: "复制",
    pnCopied: "已复制",
    pnClear: "清空",
    pnPreview: "预览产品编号（假设流水号为 X）",
    pnBaseItemTitle: "基础产品",
    pnBaseItemSub: "留空则生成新的序列号。如果填写基础产品，将在现有基础编号上进行电镀或扩展处理。",
    pnBaseItemPlaceholder: "请输入基础产品代码（例如 B20002 或 B20002J）",

    // Product PNS Table
    pnTableTitle: "产品料号",
    pnTableSearchPlaceHolder: "搜索产品",
    pnTableSearchButton: "搜索",
    pnTableHeaders: ["料号", "产品名称", "公司", "类别", "子类别", "备注"],
    pnMfgTableHeaders: ["料号", "产品名称", "产品系列", "分类", "备注"],


    // User Management
    // Users Table
    usersTableTitle: "所有员工",
    addUsersButton: "+ 新增用户",
    usersTableHeader1: "员工编号",
    usersTableHeader2: "姓名",
    usersTableHeader3: "邮箱",
    usersTableHeader4: "电话",
    usersTableHeader5: "职位",

    // View User Details
    userModalTile: "用户详情",
    userRecentActivityTitle: "最近活动",
    deleteUserBtn: "删除用户",
    editUserBtn: "编辑用户",

    // Activity Table Data
    noActivityLogFound: "未找到活动记录",
    activityTableHeader1: "用户编号",
    activityTableHeader2: "用户名",
    activityTableHeader3: "操作",
    activityTableHeader4: "状态",
    activityTableHeader5: "备注",
    activityTableHeader6: "日期",

    // Add/Edit Modal
    editImage: "编辑",
    addModalTitle: "添加用户",
    editModalTitle: "编辑用户",
    addEditModalParameter1: "姓名",
    addEditModalParameter2: "角色",
    addEditModalParameter3: "邮箱",
    addEditModalParameter4: "电话",
    addEditModalParameter5: "密码",
    addEditModalParameter6: "服务权限",
    addUserButton: "添加用户",
    updateUserButton: "更新用户",
    cancelManagingUser: "取消",
    updatingUser: "更新用户",
    addingUser: "添加用户",

    // Delete Modal
    deleteUserModalTitle: "确认删除",
    deleteUserMessage: "您确定要删除此用户吗？",
    deleteUserButton: "删除",

    // Activity Log
    activityLogTitle: "用户活动日志",
    activityLogSearchPlaceholder: "搜索用户活动...",
    activityLogId: "日志ID",
    searchButton: "搜索",

    // Tutorials Page
    tutorialsTitle: "教程与指南",

    // Tutorial 1
    tutorial1Title: "云盘标准操作流程",
    tutorial1P1: "我们的云盘部署在自有服务器上，旨在为内部文件管理和共享提供一个安全高效的平台。用户可以在该系统中上传、下载并集中管理文件。",
    tutorial1P2: "该平台可通过网页访问，使用户可以随时随地访问文件。每位用户都被分配了特定的权限，以确保数据安全和访问控制。",
    tutorial1P3: "在使用云盘时，务必遵循标准操作流程，包括规范的文件命名、文件夹管理以及权限控制，以提高系统效率并避免数据丢失。",
    tutorial1P4: "有关详细的操作步骤和说明，请参考下方提供的官方操作文档。",
    tutorial1Btn: "下载文档",

    // Tutorial 2
    tutorial2Title: "后台系统使用指南",
    tutorial2P1: "我们的后台系统用于帮助用户管理内部业务，包括用户管理、操作日志以及服务权限管理。该系统为日常业务提供了一个集中的操作平台。",
    tutorial2P2: "使用前，请先使用分配的账号登录系统。登录后，您可以根据自己的服务权限查看可用功能。",
    tutorial2P3: "不同用户根据角色拥有不同的权限。请充分了解您可使用的功能，以提升工作效率并优化操作流程。",
    tutorial2P4: "系统设计简洁易用，在熟悉权限后即可快速开始使用。",
    tutorial2Btn: "下载指南",

    // Final Note
    tutorialFinalNote: "如果您在使用系统或查看教程过程中遇到任何问题，请随时联系我们。我们将竭诚为您提供帮助。",

    // Single Product
    entryDate: "录入日期",
    entryOperator: "录入操作员",
    modifyButton: "修改数据",
    modifyModalTitle: "修改产品数据",
    noAttachment: "无附件",
    noImage: "无图片",
    saveDataButton: "保存",
    savingDataButton: "保存中",
    deleteProduct: "删除",
    deleteProductModalTitle: "确认！",
    deleteProductMessage: "您确定要删除此产品吗？",
    deleteModalButton1: "是",
    deletingProductText: "正在删除...",
    deleteModalButton2: "否",

    // Customer Development
    customerDevelopmentHomeTitle: "市场部",
    customerDevelopmentTitle: "客户开发平台（CDP）",
    totalCustomer: "客户总数",
    totalCompetitor: "竞争对手总数",
    totalContacted: "已联系总数",
    totalSampleRequest: "样品请求总数",
    totalResponded: "已回复总数",

    // Marketing Dashboard
    marketingDashboardTitle: "营销仪表板",

    // Customer Profile & Contacts
    customerProfileTitle: "客户档案",
    addEditCustomerTitle: "添加或编辑客户",
    addEditCustomerContactTitle: "添加或编辑客户联系人",

    // CDP Status Labels
    cdpStatusNew: "新建",
    cdpStatusNoResponse: "已联系 / 无回复",
    cdpStatusResponded: "已联系并回复",

    // CDP Type Labels
    cdpTypeManufacturer: "制造商",
    cdpTypeBoth: "两者",
    cdpTypeOEM: "OEM",

    // CDP Opportunity Labels
    cdpScoreLow: "低",
    cdpScoreMedium: "中",
    cdpScoreHigh: "高",
    cdpScoreStrategic: "战略",
    cdpCompanyClass: "公司分类",
    cdpCompanyClassCustomer: "客户",
    cdpCompanyClassCompetitor: "竞争对手",

    // CDP Contact Status Labels
    cdpContactNoResponse: "无回复",
    cdpContactResponded: "已回复",
    cdpContactGiveUp: "放弃",

    // CDP Supplier/Buyer
    cdpSupplier: "供应商",
    cdpBuyer: "买家",

    // CDP Delivery Status
    cdpDeliveryRequested: "已申请",
    cdpDeliveryOnPrep: "准备中",
    cdpDeliveryDelivered: "已交付",

    // CDP Activity Types
    cdpActivityContact: "联系",
    cdpActivityCall: "电话",
    cdpActivityEmail: "邮件",

    // CDP Last Contacted Through
    cdpLastContactedOptions: ["邮件", "WhatsApp", "领英", "电话", "微信", "Skype", "其他"],

    // CDP Form Labels
    cdpFormBasicInfo: "基本信息",
    cdpFormSocialMedia: "社交媒体",
    cdpFormProducts: "产品与贸易",
    cdpFormRemarks: "备注",
    cdpFormLogo: "公司标志",
    cdpFormAttachments: "相关附件",
    cdpFormCompanyName: "公司名称",
    cdpFormCountry: "国家",
    cdpFormAddress: "详细地址",
    cdpFormWebsite: "网站",
    cdpFormType: "类型",
    cdpFormSupplierBuyer: "供应商 / 买家",
    cdpFormStatus: "状态",
    cdpFormOpportunity: "机会评分",
    cdpFormEntryPersonnel: "录入人员",
    cdpFormSampleRequested: "已申请样品",
    cdpFormLinkedInId: "领英 ID",
    cdpFormOtherSocial: "其他社交媒体 ID",
    cdpFormCoreProducts: "核心产品",
    cdpFormPotentialProducts: "潜在产品",
    cdpFormTotalImports: "总进口额",
    cdpFormLastImport: "最近进口记录",
    cdpFormSave: "保存",
    cdpFormSaving: "保存中...",
    cdpFormCancel: "取消",
    cdpFormAddCompany: "添加新公司",
    cdpFormEditCompany: "编辑公司",
    cdpFormAddContact: "添加新联系人",
    cdpFormEditContact: "编辑联系人",

    // CDP Contact Form
    cdpContactName: "全名",
    cdpContactDesignation: "职位",
    cdpContactPhone: "电话号码",
    cdpContactEmail: "邮箱",
    cdpContactStatus: "状态",
    cdpContactLastThrough: "最近联系方式",
    cdpContactSocialMedia: "社交媒体联系",
    cdpContactLinkedIn: "已订阅领英页面",
    cdpContactRemarks: "备注",
    cdpContactProfilePic: "头像",
    cdpContactCompany: "所属公司",

    // CDP Profile Page
    cdpEditCompany: "编辑公司",
    cdpDeleteCompany: "删除公司",
    cdpEditContact: "编辑联系人",
    cdpDeleteContact: "删除联系人",
    cdpTabOverview: "概览",
    cdpTabContacts: "联系人",
    cdpTabTrade: "贸易数据",
    cdpTabSamples: "样品",
    cdpAddContact: "+ 添加联系人",
    cdpAddTradeData: "+ 添加贸易数据",
    cdpAddSample: "+ 添加样品申请",
    cdpNoContacts: "暂无联系人。",
    cdpNoTrade: "暂无贸易数据。",
    cdpNoSamples: "暂无样品申请。",
    cdpNoActivities: "暂无活动记录。",
    cdpAddActivity: "+ 添加活动",
    cdpDeleteConfirmTitle: "确认删除",
    cdpDeleteConfirmMsg: "您确定要删除",
    cdpDeleteBtn: "删除",
    cdpCancelBtn: "取消",

    // CDP Overview Labels
    cdpLabelAddress: "详细地址",
    cdpLabelEntryPersonnel: "录入人员",
    cdpLabelCoreProducts: "核心产品",
    cdpLabelPotentialProducts: "潜在产品",
    cdpLabelLinkedInId: "领英 ID",
    cdpLabelOtherSocial: "其他社交媒体",
    cdpLabelSampleRequested: "已申请样品",
    cdpLabelTotalImports: "总进口额",
    cdpLabelLastImport: "最近进口记录",
    cdpLabelTradeNotes: "贸易数据备注",
    cdpLabelRemarks: "备注",
    cdpLabelAttachments: "附件",
    cdpLabelSocialMedia: "社交媒体",
    cdpLabelLinkedInPage: "领英页面",
    cdpLabelLastContactedThrough: "最近联系方式",
    cdpLabelLastContactedDate: "最近联系日期",
    cdpLabelCreatedDate: "创建日期",

    // Not Found Page
    notFoundTitle: "页面未找到",
    notFoundMessage: "您访问的页面不存在。",
    notFoundBack: "返回首页",

    // Chat rooms
    chatroomName: "聊天室",
    chatroomsAll: "所有聊天室",
    chatroomsDescription: "管理和查看所有网站的访客对话",
    singleMessageName: "单条消息",

}
